var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnknownTrailer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "232px",
    height: "93px",
    viewBox: "0 0 232 93",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "unknown trailer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard---Driver-details-Copy",
    transform: "translate(-1018.000000, -478.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "main-panel",
    transform: "translate(86.000000, 119.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trailer-card",
    transform: "translate(904.000000, 96.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "unknown-trailer",
    transform: "translate(28.000000, 263.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graph/trailer_grey"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M178,69.2717495 C174.758558,62.5994047 167.916403,58 160,58 C151.107314,58 143.570176,63.8037897 140.969784,71.8301714 L67.4503811,71.8301714 C65.9839696,64.1689057 61.7713753,60.8764913 52.1529842,60.0852461 C47.8707688,60.0852461 30.4864408,60.0852461 1.16226473e-16,60.0852461 L0,0 L232,0 L232,71.8301714 C224.359034,71.8301714 218.826125,71.8301714 215.401274,71.8301714 L215.030216,71.8301714 C212.429824,63.8037897 204.892686,58 196,58 C188.083597,58 181.241442,62.5994047 178,69.2717495 Z",
    id: "Combined-Shape",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#DDDDDD",
    strokeWidth: 7,
    cx: 160,
    cy: 78,
    r: 11.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-5",
    stroke: "#DDDDDD",
    strokeWidth: 7,
    cx: 196,
    cy: 78,
    r: 11.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M111.8125,45.3125 C111.854167,42.8333209 112.135414,40.8750072 112.65625,39.4375 C113.177086,37.9999928 114.239575,36.4062588 115.84375,34.65625 L119.9375,30.4375 C121.687509,28.4583234 122.5625,26.3333447 122.5625,24.0625 C122.5625,21.8749891 121.989589,20.1614645 120.84375,18.921875 C119.697911,17.6822855 118.031261,17.0625 115.84375,17.0625 C113.718739,17.0625 112.010423,17.6249944 110.71875,18.75 C109.427077,19.8750056 108.78125,21.3854072 108.78125,23.28125 L103,23.28125 C103.041667,19.9062331 104.24478,17.182302 106.609375,15.109375 C108.97397,13.036448 112.052064,12 115.84375,12 C119.78127,12 122.848947,13.0572811 125.046875,15.171875 C127.244803,17.2864689 128.34375,20.1874816 128.34375,23.875 C128.34375,27.5208516 126.656267,31.1145656 123.28125,34.65625 L119.875,38.03125 C118.354159,39.7187584 117.59375,42.1458175 117.59375,45.3125 L111.8125,45.3125 Z M111.5625,55.21875 C111.5625,54.2812453 111.848955,53.4947948 112.421875,52.859375 C112.994795,52.2239552 113.843744,51.90625 114.96875,51.90625 C116.093756,51.90625 116.947914,52.2239552 117.53125,52.859375 C118.114586,53.4947948 118.40625,54.2812453 118.40625,55.21875 C118.40625,56.1562547 118.114586,56.9322886 117.53125,57.546875 C116.947914,58.1614614 116.093756,58.46875 114.96875,58.46875 C113.843744,58.46875 112.994795,58.1614614 112.421875,57.546875 C111.848955,56.9322886 111.5625,56.1562547 111.5625,55.21875 Z",
    id: "?",
    fillOpacity: 0.54,
    fill: "#000000",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknownTrailer);
export default __webpack_public_path__ + "static/media/unknown_trailer.b7ecaa5dae94f40e476599a4ce2b689f.svg";
export { ForwardRef as ReactComponent };